/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/userActions";
import * as settingActions from "../../../actions/settingActions";
import * as homePageActions from "../../../actions/homePageActions";
import { Container, Row, Col, Form, FormControl } from "react-bootstrap";
import Popup from "../../../Component/Popup";
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import PopupModalWithOk from "../../../utils/helpers/popupModalOk";
import { sendEmailForVerification, loadSettings } from "./Slice/signInSlice";
import PropTypes from "prop-types";

const Index = (props) => {

  const dispatch = useDispatch();
  const history = useNavigate();

  const { superUserParams, actions } = props;
  const [signupModalShow, setSignupModalShow] = useState(false);
  const [popUpLoader, setPopUpLoader] = useState(false);
  const { userInfo, setting } = useSelector((state) => state.signIn);

  useEffect(() => {
    const isRegistering = localStorage.getItem("registration_in_progress");

    if (userInfo?.id && !isRegistering) {
      history("/dashboard");
    }
  }, [userInfo, history]);

  const { register, reset, handleSubmit, control, formState: { errors } } = useForm({ defaultValues: superUserParams })
  const [rememberMe] = useState(localStorage.getItem('rememberMe') === 'true');

  const [apiMessage] = useState("");
  const [apiModalShow, setApiModalShow] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const siteName = setting?.name?.trim() || "Login to Your Account";

  useEffect(() => {
    const title = `${siteName} - Login to Your Account`;

    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        `Login to your ${siteName} account to access one-to-one, domain-specific career mentoring between aspiring women leaders and experienced industry leaders.`
      );
    }

    window.scrollTo(0, 0);
  }, [siteName]);

  const isToken = localStorage.getItem("deviceToken");

  useEffect(() => {
    // Prefill credentials if remembered
    if (rememberMe) {
      reset({
        email: localStorage.getItem('email') || '',
        password: localStorage.getItem('password') || '',
        remember_me: true,
      });
    } else {
      reset({ remember_me: false });
      localStorage.removeItem('email');
      localStorage.removeItem('password');
    }
  }, []);

  const onSubmit = async (data) => {
    localStorage.removeItem("email");
    localStorage.removeItem("password");
    localStorage.removeItem("userId");

    let params = {
      ...data,
      device_type: "web",
      device_token: isToken,
      role_id: ["Mentor", "Mentees"],
    };

    try {
      const result = await actions.userLoginData(params);
      if (result?.status === 422) {
        setPopupMessage(result?.message);
        setShowPopup(true); // show popup for validation errors
        return;
      }
      if (result?.status === 200 && params.avl_resume === "1") {
        setPopupMessage(result?.message);
        setShowPopup(true); // show popup on success
      }
      // Remember me handling
      if (data.remember_me) {
        localStorage.setItem("email", data?.email);
        localStorage.setItem("password", data?.password);
      } else {
        localStorage.removeItem("email");
        localStorage.removeItem("password");
      }
      localStorage.setItem("rememberMe", data.remember_me.toString());
    } catch (err) {
      console.error("Login error:", err);
      setPopupMessage("An unexpected error occurred. Please try again.");
      setShowPopup(true);
    }
  };

  const getSignupPopup = () => {
    if (setting.email_approval_required === 1) {
      setSignupModalShow(true);
    } else {
      history("/register");
    }
  };


  const handleSubmitCheckEmail = async (data) => {
    try {
      setPopUpLoader(true);

      const action = await dispatch(sendEmailForVerification(data));
      const result = action.payload;

      setPopUpLoader(false);

      // ✅ FIXED: correct response path
      if (result?.data?.sso_verifed === true) {
        localStorage.setItem("registration_in_progress", "true");
        setSignupModalShow(false);
        history("/registration-step-1");
        return;
      }

      // normal success
      setSignupModalShow(false);
      setPopupMessage(result?.message || "Verification email sent successfully!");
      setShowPopup(true);

    } catch (err) {
      setPopUpLoader(false);

      setPopupMessage(
        err?.payload?.message ||
        err?.message ||
        "Failed to send verification email."
      );
      setShowPopup(true);
    }
  };

  useEffect(() => {
    dispatch(loadSettings());
  }, [dispatch]);

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <>
      <section className="loginouter">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={12}>
              <div className="logininnerouter resetouter">
                <div>
                  <div className="loginlogo text-center mb-5">
                    <Link to="/" className="logo m-0">
                      <img
                        src={setting?.logo_path}
                        style={{ maxWidth: '200px', maxHeight: '59px' }}
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="loginform">
                    <h1>Login</h1>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Row>
                        {/* Email */}
                        <Col md={12} sm={12}>
                          <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Controller
                              name="email"
                              control={control}
                              rules={{
                                required: "Please enter your email address",
                                pattern: {
                                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: "Invalid email address",
                                },
                                maxLength: {
                                  value: 50,
                                  message: "Your email should contain max 50 characters",
                                },
                              }}
                              render={({ field }) => (
                                <FormControl
                                  {...field}
                                  type="email"
                                  placeholder="Email Address"
                                  className={errors.email ? "formError" : ""}
                                  aria-invalid={errors.email ? "true" : "false"}
                                />
                              )}
                            />
                            {errors.email && (
                              <span style={{ color: "red", fontSize: "15px" }}>
                                {errors.email.message}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                        {/* Password */}
                        <Col md={12}>
                          <Form.Group className="mb-3" controlId="formBasicPassword">
                            <div style={{ position: "relative" }}>
                              <Controller
                                name="password"
                                control={control}
                                rules={{ required: "Please enter your password" }}
                                render={({ field }) => (
                                  <FormControl
                                    {...field}
                                    type={showPassword ? "text" : "password"}
                                    className={errors.password ? "formError" : ""}
                                    style={{ paddingRight: "43px" }}
                                    placeholder="Password"
                                    aria-invalid={errors.password ? "true" : "false"}
                                  />
                                )}
                              />
                              <button
                                type="button"
                                className="password-toggle-icon"
                                onClick={togglePasswordVisibility}
                                style={{
                                  all: "unset",
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "21px",
                                  top: "46%",
                                  transform: "translateY(-50%)",
                                }}
                              >
                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                              </button>
                            </div>
                            {errors.password && (
                              <span style={{ color: "rgb(220, 53, 69)", fontSize: "15px" }}>
                                {errors.password.message}
                              </span>
                            )}
                          </Form.Group>
                        </Col>
                        {/* Remember me */}
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Check
                              className="d-flex align-items-center gap-2"
                              type="checkbox"
                              label="Remember me"
                              {...register("remember_me")}
                              defaultChecked={rememberMe}
                            />
                          </Form.Group>
                        </Col>
                        {/* Forgot password */}
                        <Col md={6} className="text-end">
                          <Form.Group className="mb-3">
                            <Link to="/forgotPassword" className="text-danger">
                              Forgot Password
                            </Link>
                          </Form.Group>
                        </Col>
                        {/* Submit */}
                        <Col md={12}>
                          <div className="form-group mt-3 mb-3">
                            <button type="submit" className="btn w-100 loginsubmit">
                              Login
                            </button>
                          </div>
                        </Col>
                        {/* Signup */}
                        <Col md={12} className="text-center">
                          <Form.Group>
                            Create a new account?&nbsp;
                            <Link to="#" onClick={() => { getSignupPopup() }} className="text-danger">
                              Sign Up
                            </Link>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {signupModalShow && (
        <Popup
          show={signupModalShow}
          handleSubmitCheckEmail={handleSubmitCheckEmail}
          onHide={() => setSignupModalShow(false)}
          setPopUpLoader={setPopUpLoader}
          popUpLoader={popUpLoader}
        />
      )}
      {apiModalShow && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{apiMessage}</p>
            <button onClick={() => setApiModalShow(false)}>OK</button>
          </div>
        </div>
      )}
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Index.propTypes = {
  actions: PropTypes.shape({
    userLoginData: PropTypes.func.isRequired,
    sendEmailForVerification: PropTypes.func.isRequired,
    loadSettings: PropTypes.func.isRequired,
  }).isRequired,
  superUserParams: PropTypes.object.isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string,
    logo_path: PropTypes.string,
    email_approval_required: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  title: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    superUserParams: state.superUserParams,
    userInfo: state.userInfo,
    setting: state.setting
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...userActions, ...settingActions, ...homePageActions
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
